import { slider } from "../../../assets/js/modules/_slider.js";

const config = {
	wrap: ".card-slider__inner",
	next: ".card-slider__next",
	prev: ".card-slider__prev",
	items: ".card-slider__inner .card",
};

export const instances = Array.from(
	document.querySelectorAll( '.card-slider' )
).map( node => slider( node, config ) );
